import React, { useState } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { BaseUrl } from "../../Environment";
import { Stack, Typography, Snackbar, Alert } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { getSecureItem } from "../../utilsFunctions";
import Axios from "axios";

function PaymentFormCredits({ credits, amount }) {
  const userDetails = getSecureItem("loggedinUser");

  const stripe = useStripe();
  const elements = useElements();

  const [btnLoading, setBtnLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [toastMsg, setToastMsg] = useState({
    msg: "",
    time: 2000,
    variant: "success",
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateCredits = async () => {
    try {
      let loggedinUser = getSecureItem("loggedinUser");

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getSecureItem("token"),
      };

      const payload = {
        companyId: loggedinUser.companyId,
        credits,
      };

      const resp = await Axios.put(BaseUrl + "/user/updateCredits", payload, {
        headers: headers,
      });

      return resp;
    } catch (error) {
      console.log("error", error);
    }
  };

  const createSubscription = async () => {
    setBtnLoading(true);
    try {
      const cardElement = elements.getElement(CardNumberElement);

      const { paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });

      if (paymentMethod?.id) {
        const response = await fetch(`${BaseUrl}/creditPayment`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: `${userDetails?.firstName} ${userDetails?.lastName}`,
            email: userDetails?.userEmail,
            paymentMethod: paymentMethod?.id,
            price: amount,
          }),
        });

        const data = await response.json();
        // console.log("subscribePayment", data);

        if (data?.clientSecret) {
          const confirm = await stripe.confirmCardPayment(data?.clientSecret);
          // console.log("confirm", confirm);

          if (confirm?.paymentIntent?.status === "succeeded") {
            const updateRes = updateCredits();
            // console.log("updateRes", updateRes);

            try {
              const response = await updateRes;
              console.log("hhh", response.data);

              const { status } = response.data;

              if (status) {
                setToastMsg({
                  msg: `Payment Successful! WhatsApp credits added successfully.`,
                  time: 5000,
                  variant: "success",
                });

                setTimeout(() => {
                  handleOpen();
                }, 500);

                setTimeout(() => {
                  window.location.reload();
                }, 4000);
              }
            } catch (error) {
              console.error("Error:", error);
            }
          } else {
            setToastMsg({
              msg: confirm.error?.message,
              time: 5000,
              variant: "error",
            });

            setTimeout(() => {
              handleOpen();
            }, 500);
          }
        } else {
          setToastMsg({
            msg: data?.message,
            time: 5000,
            variant: "error",
          });

          setTimeout(() => {
            handleOpen();
          }, 500);
        }
      } else {
        setToastMsg({
          msg: "Invalid Payment Method",
          time: 4000,
          variant: "error",
        });

        setTimeout(() => {
          handleOpen();
        }, 500);
      }

      setBtnLoading(false);
    } catch (err) {
      console.log("err", err);
      setBtnLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Snackbar
        open={open}
        autoHideDuration={toastMsg.time}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={toastMsg.variant}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toastMsg.msg}
        </Alert>
      </Snackbar>
      <div style={{ minWidth: "300px", width: "600px" }}>
        <Stack spacing={2}>
          <Stack spacing={1} className="paymentElm">
            <Typography>CARD NUMBER</Typography>
            <CardNumberElement
              id="cardNumber"
              options={{
                style: {
                  base: {
                    fontSize: "16px",
                    color: "#424770",
                    padding: "20px",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                },
              }}
            />
          </Stack>

          <Stack spacing={1} className="paymentElm">
            <Typography>EXPIRY DATE (MM/YY)</Typography>
            <CardExpiryElement
              id="cardExpiry"
              options={{
                style: {
                  base: {
                    fontSize: "16px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                },
              }}
            />
          </Stack>

          <Stack spacing={1} className="paymentElm">
            <Typography>CVV/CVC</Typography>
            <CardCvcElement
              id="cardCvc"
              options={{
                style: {
                  base: {
                    fontSize: "16px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                },
                placeholder: "CVV",
              }}
            />
          </Stack>

          <LoadingButton
            onClick={createSubscription}
            fullWidth
            variant="contained"
            sx={{ width: "200px", fontSize: "10px", color: "#fff" }}
            align="center"
            color="success"
            loading={btnLoading}
          >
            Buy Credits
          </LoadingButton>
        </Stack>
      </div>
    </div>
  );
}

export default PaymentFormCredits;
